const en = {
  common: {
    actions: "Actions",
    actualCost: "Actual cost",
    add: "Add",
    addComponent: "Add Component",
    allRequests: "All requests",
    allowQuantityVariation: "Allow quantity variation",
    alreadyPresent: "Already present",
    ascending: "Ascending",
    availabilityDate: "Availability Date",
    author: "Author",
    by: "By",
    cancel: "Cancel",
    close: "Close",
    closedAndDiscarded: "Closed and discarded",
    code: "Code",
    columnNotFilterable: "This column is not filterable",
    columnNotSortable: "This column is not sortable",
    componentCantBeFinalItem: "The component can't be the same as the final item.",
    components: "Components",
    costs: "Costs",
    cost: "Cost",
    costPerUnit: "Cost per unit",
    createdAt: "Created at",
    totalCost: "Total cost",
    createRequest: "Create request",
    createsKit: "Creates Kit",
    dataHasBeenSavedSuccessfully: "Data has been saved succesfully.",
    dataSyncedSuccessfully: "Data synced successfully",
    days: "Days",
    decrease: (value: number) => `Decrease ${value}`,
    delete: "Delete",
    deleteFilter: (filter: string) => `Delete filters for ${filter}`,
    description: "Description",
    descending: "Descending",
    download: "Download",
    dragAndDropOrUploadAnFile: "Drag and Drop or click to upload a file",
    dropIt: "Drop it",
    edit: "Edit",
    editMinutes: "Edit Minutes",
    email: "Email",
    empty: "Empty",
    english: "English",
    errorLoadingData: "Error loading data",
    expectedCost: "Expected cost",
    expectedMinutes: "Expected minutes",
    expectedQuantity: "Expected quantity",
    exportExcel: "Export Excel",
    fieldCannotBeEmpty: "The field cannot be empty.",
    fieldContainsInvalidValueInsertBiggerOne: "The field contains an invalid value, insert a bigger one.",
    fieldContainsInvalidValueInsertSmallerOne: "The field contains an invalid value, insert a smaller one.",
    fieldInvalidValue: "The field contains an invalid value.",
    fieldValueInvalidFormat: "The value has an invalid format.",
    finalItem: "Final item",
    finalItemCode: "Final item code",
    finalItemQuantity: "Final item quantity",
    firstName: "First name",
    genericError: "An error has occurred, please try again.",
    generalData: "General data",
    german: "German",
    groupedByItems: "Grouped by items",
    helmets: "Helmets",
    home: "Home",
    minutes: "Minutes",
    id: "ID",
    increase: (value: number) => `Increase ${value}`,
    initialItem: "Initial item",
    initialItemIsFinalItem: "Initial item is final item",
    initialItemQuantity: "Initial item quantity",
    isKit: "Is kit",
    italian: "Italian",
    item: "Item",
    // itemsPerPackage: "Items per package",
    label: "Label",
    lastName: "Last name",
    loading: "Loading",
    logout: "Logout",
    manageCosts: "Manage costs",
    myArea: "My area",
    myRequests: "My requests",
    name: "Name",
    nextNRows: (n: number) => `Next ${n} rows`,
    new: "New",
    newLabelOrPackaging: "New label/packaging",
    no: "No",
    noItemsFound: "No elements found.",
    notFound: "Not found",
    offerMandatory: "Offer mandatory",
    onGoing: "On going",
    optional: "Optional",
    organization: "Organization",
    overwrite: "Overwrite",
    packaging: "Packaging",
    permissions: "Permissions",
    producesKit: "Produces kit",
    productionPickingNumber: "Production/Picking number",
    priorities: "Priorities",
    priority: "Priority",
    processingType: "Processing type",
    processingTypes: "Processing types",
    previousNRows: (n: number) => `Previous ${n} rows`,
    pz: "PZ",
    quantity: "Quantity",
    rename: "Rename",
    requests: "Requests",
    requestsByItem: "Requests by item",
    requestType: "Request type",
    resourceNotFound: "The resource you are looking for has not been found.",
    roles: "Roles",
    save: "Save",
    search: "Search",
    select: "Select",
    selectRequestType: "Select a request type.",
    send: "Send",
    sendOfferTo: "Send Offer to",
    showsMarketingFields: "Shows marketing fields",
    status: "Status",
    supervisor: "Supervisor",
    sync: "Sync",
    testEnvironment: "Test environment",
    totalAttachedDocuments: "Total attached documents",
    type: "Type",
    types: "Types",
    unitOfMeasure: "Unit of measure",
    update: "Update",
    usedProducts: "Used products",
    usedProductsFor: "Used products for ",
    usedQuantity: "Used quantity",
    views: "Views",
    workingMinutes: "Working minutes",
    writeMessage: "Write a message",
    yes: "Yes",
    youAreNotAllowedToAccessThisApplication: "You are not allowed to access this application",
  },

  groupedRequests: {
    numberOfRequests: "Number of requests",
    totalExpectedMinutes: "Total expected minutes",
    totalExpectedMinutesCost: "Total expected minutes cost",
    productionTotalMinutes: "Total production minutes",
    totalProductionMinutesCost: "Total production minutes cost",
    totalInitialItemsCost: "Total initial items cost",
    totalPackagingsAndLabelsCost: "Total packagings and labels cost",
    short: {
      numberOfRequests: "Nr. of requests",
      totalExpectedMinutes: "Tot. expected min.",
      totalExpectedMinutesCost: "Tot. expected min. cost",
      productionTotalMinutes: "Tot. prod. min.",
      totalProductionMinutesCost: "Tot. prod. min. cost",
      totalInitialItemsCost: "Tot. initial items cost",
      totalPackagingsAndLabelsCost: "Tot. pack. and labels cost",
    },
  },

  processingRequests: {
    delete: "Delete processing request",
    plural: "Processing requests",
    newProcessingRequest: "New processing request",
    editProcessingRequest: "Edit processing request",
    editAvailabilityDate: "Edit availability date",
    requestRecap: "Request recap",

    questions: {
      delete: "Do you really want to delete this processing request?",
    },

    errors: {
      finalItemMoreInitialItems: "A final item can contain only one initial item",
      invalidAvailabilityDate: "Invalid availability date",
      notFound: "Processing request not found",
      missingFinalItem: "A processing request must include at least one final item",
      missingKitComponents: "A kit processing request must include at least one component",
      missingPackagingsOrLabels: "The request requires packagings or labels to proceed",
      missingExpectedMinutes: "Expected minutes are required to proceed",
      missingProductionMinutes: "Production minutes are required to proceed",
    },

    status: {
      open: "Open",
      accepted: "Accepted",
      waitingConfirmation: "Waiting-confirmation",
      offerApproved: "Offer-approved",
      inProgress: "In-progress",
      closed: "Closed",
      refused: "Refused",
      discarded: "Discarded",
      actions: {
        takeInCharge: "Take in charge",
        sendOffer: "Send offer",
        accept: "Accept",
        refuse: "Refuse",
        discard: "Discard",
        start: "Start",
        finishClose: "Finish/Close",
      },
      executedActions: {
        requestCreated: "Request created",
        requestAccepted: "Request accepted",
        offerSent: "Offer sent",
        offerApproved: "Offer approved",
        workStarted: "Work started",
        workCompleted: "Work completed",
        offerRefused: "Offer refused",
        requestDiscarded: "Request discarded",
      },
    },
  },

  labels: {
    plural: "Labels",
    delete: "Delete label",
    newLabel: "New label",
    editLabel: "Edit label",

    questions: {
      delete: "Do you really want to delete this label?",
    },

    errors: {
      notFound: "The requested label could not be found",
      codeExists: "A label with the specified code is already defined",
      inUseByRequests: "The label is still in use and can't be deleted",
    },
  },

  items: {
    plural: "Items",
    delete: "Delete item",
    newItem: "New item",
    editItem: "Edit item",
    deleteKitAndComponents: "Delete kit & components",
    deleteJustKit: "Delete just the kit",
    deleteComponentsInfo: "The components used in other kits or requests won't be deleted",

    questions: {
      deleteComponents: "Do you want to delete the components associated with this item?",
      delete: "Do you really want to delete this item?",
    },

    errors: {
      notFound: "The requested item could not be found",
      alreadyExists: "The specified item is already defined",
      inUseByRequests: "The item is still in use and can't be deleted",
      alreadyAdded: "The selected item has already been added",
    },
  },

  users: {
    plural: "Users",
    addUser: "Add User",
    editUser: "Edit User",

    errors: {
      notFound: "The requested user could not be found",
      alreadyExists: "The selected user has already been added",
      emailAlreadyExists: "Another user with the same email has already been added",
    },
  },

  costCenters: {
    singular: "Cost center",
    plural: "Cost centers",
    delete: "Delete cost center",
    newCostCenter: "New cost center",
    editCostCenter: "Edit cost center",

    questions: {
      delete: "Do you really want to delete this cost center?",
    },

    errors: {
      notFound: "The requested cost center could not be found",
      codeUsed: "A cost center with the specified code is already defined",
      nameUsed: "A cost center with the specified name is already defined",
      inUseByRequests: "The cost center is still in use and can't be deleted",
    },
  },

  costObjects: {
    singular: "Cost object",
    plural: "Cost objects",
  },

  documents: {
    add: "Add document",
    all: "All documents",
    alreadyPresent: "Document already present.",
    plural: "Documents",
    delete: "Delete document",
    rename: "Rename document",
    search: "Search documents",

    questions: {
      delete: "Do you really want to delete this document?",
      overwrite: "Do you want to overwrite the already present document?",
    },

    errors: {
      nameAlreadyExists: "A document with this name already exists",
      extensionChanged: "The document's extension cannot be changed",
      sizeTooLarge: "The document size is too large",
    },
  },

  notes: {
    note: "Note",
    addNote: "Add note",
    editNote: "Edit Note",
    plural: "Notes",
  },

  priorities: {
    plural: "Priorities",
    delete: "Delete priority",
    newPriority: "New priority",
    editPriority: "Edit priority",

    questions: {
      delete: "Do you really want to delete this priority?",
    },

    errors: {
      notFound: "The requested priority could not be found",
      nameUsed: "A priority with the specified name is already defined",
      inUseByRequests: "The priority is still in use and can't be deleted",
    },
  },

  packagings: {
    plural: "Packagings",
    delete: "Delete packaging",
    newPackaging: "New packagings",
    editPackaging: "Edit packagings",

    questions: {
      delete: "Do you really want to delete this packaging?",
    },

    errors: {
      notFound: "The requested packaging could not be found",
      codeExists: "A packaging with the specified code is already defined",
      inUseByRequests: "The packaging is still in use and can't be deleted",
    },
  },

  processingRequestTypes: {
    delete: "Delete request type",
    newType: "New request type",
    editType: "Edit request type",

    questions: {
      delete: "Do you really want to delete this request Type?",
    },

    errors: {
      notFound: "The requested type could not be found",
      nameUsed: "A processing request type with the specified name is already defined",
      inUseByRequests: "The processing request type is still and can't be deleted",
    },
  },

  suppliers: {
    singular: "Supplier",
    plural: "Suppliers",
    delete: "Delete supplier",
    newSupplier: "New supplier",
    editSupplier: "Edit supplier",

    questions: {
      delete: "Do you really want to delete this supplier?",
    },

    errors: {
      notFound: "The requested supplier could not be found",
      codeUsed: "A supplier with the specified code is already defined",
      inUseByRequests: "The supplier is still in use and can't be deleted",
    },
  },

  errors: {
    genericError: "An error has occurred, please try again.",
    finalItemCannotMatchInitialItem: "The final item can't match the initial item",
  },

  warnings: {
    notAllComponentsDeleted: "Some of the kit components have been deleted",
  },
};
export default en;
